// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("./images/background.jpg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".our-differences{background:linear-gradient(0deg, rgba(16,65,130,0.2), rgba(16,65,130,0.2)),url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") no-repeat right center/cover}.our-differences h2{color:#fff}\n", ""]);
// Exports
module.exports = exports;
